import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
  .rc-virtual-list-holder
     {
        
     }
     .ant-select-tree-list-holder     {
      //  max-height: 25vh !important; 
     }
  }


`

export default GlobalStyle
